var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSkipNext = function SvgSkipNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M660-280v-400q0-17 11.5-28.5T700-720t28.5 11.5T740-680v400q0 17-11.5 28.5T700-240t-28.5-11.5T660-280m-440-35v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T548-480t-4.5 18.5T530-447L282-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29"
  })));
};
export default SvgSkipNext;